"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLegalFormDisclaimerWrapper = exports.StyledMasterWrapper = exports.StyledSelectGroup = exports.StyledSubmitButton = exports.RadioGroupLabelWrapper = exports.RadioGroupWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.RadioGroupWrapper = components_core_1.styled.div `
  color: #001e50;
  display: block;
`;
exports.RadioGroupLabelWrapper = components_core_1.styled.div `
  padding-bottom: 22px;
`;
exports.StyledSubmitButton = components_core_1.styled.div `
  padding-top: 11px;
  @media (min-width: ${components_core_1.Breakpoints.b960}px) {
    padding-top: 21px;
  }
`;
exports.StyledSelectGroup = components_core_1.styled.div `
  display: flex;
  width: 100%;
  flex-flow: column;
  & > :first-child {
    padding-bottom: 48px;
  }
  @media (min-width: ${components_core_1.Breakpoints.b960}px) {
    flex-flow: unset;
    & > :first-child {
      padding-bottom: 0;
    }
  }
`;
exports.StyledMasterWrapper = components_core_1.styled.div `
  margin-right: 30px;
  width: 100%;
`;
exports.StyledLegalFormDisclaimerWrapper = components_core_1.styled.span `
  color: #3c484d;

  a {
    font-weight: 700;
  }
`;
